module.exports = __webpack_public_path__ + "img/logo.d52bbe2f.png";